/**
 * A very small publish/subscribe helper for sign-out events.
 *
 * The API layer sits below React, so it cannot navigate or show a message by
 * itself. When it decides the session is over it announces that here, and the
 * React side reacts (clears cached data, sends the user to the sign-in screen).
 */

export type SignedOutReason = 'revoked' | 'expired' | 'manual';

type Listener = (reason: SignedOutReason) => void;

const listeners = new Set<Listener>();

export const authEvents = {
  /** Registers a listener. Returns a function that removes it again. */
  onSignedOut(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  emitSignedOut(reason: SignedOutReason): void {
    for (const listener of listeners) {
      listener(reason);
    }
  },
};
